/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DtoTravelBookingGmgAddAdvance } from '../../models/dto-travel-booking-gmg-add-advance';
import { TravelBookingCreateResponseRedirect } from '../../models/travel-booking-create-response-redirect';

export interface BookingControllerAddAdvanceForGmg$Params {
  booking_identifier: string;
      body: DtoTravelBookingGmgAddAdvance
}

export function bookingControllerAddAdvanceForGmg(http: HttpClient, rootUrl: string, params: BookingControllerAddAdvanceForGmg$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelBookingCreateResponseRedirect;
}>> {
  const rb = new RequestBuilder(rootUrl, bookingControllerAddAdvanceForGmg.PATH, 'put');
  if (params) {
    rb.path('booking_identifier', params.booking_identifier, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TravelBookingCreateResponseRedirect;
      }>;
    })
  );
}

bookingControllerAddAdvanceForGmg.PATH = '/booking/{booking_identifier}/add-advance';
